
import { defineComponent, inject, onMounted, Ref, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Markdown from "vue3-markdown-it";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import RoomFilter from "@/components/hotels/RoomFilter.vue";
import { Hotel } from "@/vue-core/models/Hotel.model";
export default defineComponent({
  components: {
    Markdown,
    CoronaRoomFilter: RoomFilter,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const room = ref(null);
    const eventID = route.params.eventID;
    const hotelID = route.params.hotelID;
    const roomID = route.params.roomID;
    const actualDate = ref(new Date().toLocaleDateString());
    const hotelDetails: Ref<Hotel | null> = ref(null);

    const emitter: any = inject("emitter");
    const toggleRoomFilter = () => {
      emitter.emit("toggleRoomFilter", true);
    };

    const getRoomDetails = (roomData) =>
      store.dispatch("user/roomDetailsData", roomData);
    const hotelDetailsInfo = (hotelData) =>
      store.dispatch("user/getHotelDetails", hotelData);
    onMounted(async () => {
      const hDetails: Hotel = await hotelDetailsInfo({
        eventID: eventID,
        hotelID: hotelID,
      });
      hotelDetails.value = hDetails;
      const roomDetails = await getRoomDetails({
        eventID: eventID,
        hotelID: hotelID,
        roomID: roomID,
      });
      if (roomDetails.lock) {
        await router.push({
          name: "Hotels",
          params: { eventID: eventID },
        });
      }
      room.value = roomDetails;
      const initialDate = new Date(roomDetails.startDate);
      const endDatePlusOne = roomDetails.endDate.setDate(
        roomDetails.endDate.getDate() + 1
      );
      const endDate = new Date(endDatePlusOne).toISOString().slice(0, 10);
      const startDate = new Date(roomDetails.startDate)
        .toISOString()
        .slice(0, 10);
      const calendarID: HTMLElement = document.getElementById("calendar")!;
      const calendar = new Calendar(calendarID, {
        plugins: [dayGridPlugin],
        initialView: "dayGridMonth",
        initialDate: initialDate,
        editable: false,
        selectable: true,
        contentHeight: "auto",
        headerToolbar: {
          left: "prev,next",
          center: "title",
          right: "dayGridMonth",
        },
        events: [
          {
            start: startDate,
            end: endDate,
            display: "background",
          },
        ],
      });
      calendar.render();
    });

    return {
      room,
      getRoomDetails,
      toggleRoomFilter,
      hotelDetails,
      actualDate,
    };
  },
});
